import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconFullscreen = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "M5 5h5V3H3v7h2zm5 14H5v-5H3v7h7zm11-5h-2v5h-5v2h7zm-2-4h2V3h-7v2h5z" }, void 0) }, void 0));
const Memo = memo(SvgIconFullscreen);
export default Memo;
//# sourceMappingURL=IconFullscreen.js.map